import React, { memo } from 'react';
import { Handle, Position } from '@xyflow/react';
import { LuRadio, LuWifiOff, LuServer, LuTriangleAlert } from 'react-icons/lu';
import { gatewayStatusLabel, normalizeGatewayStatus } from '../../utils/gatewayStatus';

const GatewayNode = ({ data, selected }) => {
  const {
    name,
    mac_address,
    status,
    mqtt_broker_host,
    mqtt_topic,
    isConnected,
  } = data;

  const gatewayStatus = normalizeGatewayStatus(status);
  const isOnline = gatewayStatus === 'online';
  const isWarning = gatewayStatus === 'warning';
  const statusLabel = gatewayStatusLabel(gatewayStatus);

  return (
    <div
      className={`gateway-node ${selected ? 'selected' : ''} ${gatewayStatus}`}
      data-testid={`gateway-node-${mac_address}`}
    >
      <div className="gateway-node-header">
        <div className="gateway-node-icon">
          <LuRadio className="w-5 h-5" />
        </div>
        <div className="gateway-node-status">
          {isOnline ? (
            <span className="status-dot online" title="Gateway online" />
          ) : isWarning ? (
            <LuTriangleAlert className="w-4 h-4 text-amber-400" title="Gateway stale" />
          ) : (
            <LuWifiOff className="w-4 h-4 text-zinc-500" title="Gateway offline" />
          )}
        </div>
      </div>

      <div className="gateway-node-content">
        <div className="gateway-node-name">{name || 'Gateway'}</div>
        <div className="gateway-node-mac">{mac_address}</div>

        <div className="gateway-node-details">
          <div className="gateway-node-detail">
            <LuServer className="w-3 h-3" />
            <span>{mqtt_broker_host || 'Not configured'}</span>
          </div>
          <div className="gateway-node-detail">
            <LuRadio className="w-3 h-3" />
            <span className="truncate">{mqtt_topic || 'No topic'}</span>
          </div>
        </div>
      </div>

      <div className="gateway-node-footer">
        <span className={`gateway-status-badge ${gatewayStatus}`}>
          {statusLabel}
        </span>
        {isConnected && (
          <span className="gateway-connected-badge" title="ETL broker session active">
            Broker
          </span>
        )}
      </div>

      <Handle
        type="source"
        position={Position.Right}
        id="output"
        className="gateway-handle"
      />
    </div>
  );
};

export default memo(GatewayNode);
